"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReimbursementFormData = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const PaymentDetails_1 = require("./PaymentDetails");
class ReimbursementFormData extends base_models_1.Serializable {
    constructor() {
        super(...arguments);
        this.automaticTariffUpdate = false;
    }
}
exports.ReimbursementFormData = ReimbursementFormData;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 0.3876, description: 'Charge tariff per kWh incl. VAT' }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Number)
], ReimbursementFormData.prototype, "chargingTariff", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({ example: false, description: 'Automatic tariff update' }),
    tslib_1.__metadata("design:type", Object)
], ReimbursementFormData.prototype, "automaticTariffUpdate", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => PaymentDetails_1.LeadFormPaymentDetails),
    (0, class_validator_1.ValidateNested)(),
    (0, base_models_1.Docs)({
        example: { iban: 'NL67ABNA0540782890', accountHolder: 'J. Jansen' },
        description: 'Reimbursement payment details',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", PaymentDetails_1.LeadFormPaymentDetails)
], ReimbursementFormData.prototype, "paymentDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, base_models_1.Docs)({
        example: true,
        description: 'Only allow charging with known essent cards',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", Boolean)
], ReimbursementFormData.prototype, "chargeWithCard", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.Matches)(/^NL-ESS-[CD]\d{8}-[A-Z0-9]$/),
    (0, base_models_1.Docs)({
        example: 'NL-ESS-C12345678-A',
        description: 'Charge card identifier',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], ReimbursementFormData.prototype, "chargeCardIdentifier", void 0);
